import _ from 'lodash';
import { toLower, replace } from 'lodash';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PT from 'prop-types';
import {
  Icon,
  Table,
  Popup,
} from 'semantic-ui-react';
import {
  selectWeeksWithPreSeasonForDropdown,
} from '../../../store/reducers/season';
import { positionToTitle } from '../../../lib/lookups';
import {
  selectPrint,
  selectPrintState,
  PRINT_VIEW,
} from './module/print';
import TableControls from '../../components/TableControls';
import { Image } from 'semantic-ui-react';
import { PLAYER_VIEW } from '../Player/module/player';
import injuryIcon from '../../../assets/images/injury-icon.png';
import rookieIcon from '../../../assets/images/icon-rookie.png';
import upsideIcon from '../../../assets/images/upside.png';
import downsideIcon from '../../../assets/images/downside.png';
import analysisIcon from '../../../assets/images/icon-analysis.png';
import Link from '../../../lib/components/link';
import { selectFormulas } from '../../../store/reducers/formula';
import moment from 'moment';
import logo from '../../../assets/images/huddle-logo.svg';
import classes from './Print.css';


const mapStateToProps = state => {
    const { hasLoaded, year, week, formulaId, title, rookiesOnly } = selectPrintState(state);

    return {
      hasLoaded,
      selectedYear: year,
      selectedWeek: week,
      selectedProfile: formulaId,
      title: title,
      rookiesOnly: rookiesOnly,
      ...hasLoaded && {
        print: selectPrint(state),
        weeks: selectWeeksWithPreSeasonForDropdown(state, year, 'projections'),
        profiles: selectFormulas(state),
      },
    };
};
export class Print extends PureComponent {


  static defaultProps = {
    weeks: [
      { key: 0, value: 0, text: 'Pre Season' },
    ],
    print: null,
    selectedWeek: null,
    selectedYear: null,
    selectedProfile: null,
    rookiesOnly: false,
    profiles: [],
    title: '',
  }


  /* Tier Names */
  numeralNames = ['', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT']


  renderPlayerRow = ({ player_id: id, rank, pcnt, fpts, position, fname, lname, team, bye, writeup, injured, rookie, upside, downside, opponent }) => {
    const name = `${fname} ${lname}`;
    const goPlayer = id => ({ type: PLAYER_VIEW, payload: { id, name: toLower(replace(fname + lname, /\./g, '')) } });
    let title = this.props.title;
    return (
      <Table.Row key={id}>
        <Table.Cell textAlign="center" className={`${classes.contentCell} ${classes.rankCell}`} >
          { (title.indexOf('auction-') === -1) ? `${rank}.` : `${pcnt}%`}
        </Table.Cell>
        {title === 'cheatsheets' && <Table.Cell textAlign="center" className={classes.contentCell}>{fpts}</Table.Cell>}
        {(title.indexOf('top-200') > -1) && <Table.Cell textAlign="center" className={classes.contentCell}>{position}</Table.Cell>}
        <Table.Cell textAlign="center" className={`${classes.contentCell} ${classes.playerContentCell}`}>
            <div className={injured === 1 ? classes.nameIndi : classes.noInjuredNameIndi}>
                <span className={classes.nameAlign}>{fname}&nbsp;</span>
                <div className={classes.nameIndi2}>
                  <span className={classes.nameAlign}>{lname}</span>
                  {rookie==="Y" ? <img src={rookieIcon} alt="" className={classes.rookieIcon} /> : ""}

                  {upside==="Y" ? <img src={upsideIcon} alt="" className={classes.upsideIcon} /> : ""}

                  {downside==="Y" ? <img src={downsideIcon} alt="" className={classes.downsideIcon} /> : ""}
                </div>
              </div>

              { /* {injured === 1 && <img src={injuryIcon} alt="" className={classes.injuryIcon} />} */ }
        </Table.Cell>
        <Table.Cell textAlign="center" className={classes.contentCell}>{team}</Table.Cell>
        {
          title === 'cheatsheets'
          ? (
              this.props.selectedWeek < 1
              ? <Table.Cell textAlign="center" className={classes.contentCell}>{bye}</Table.Cell>
              : <Table.Cell textAlign="center" className={classes.contentCell}>{opponent}</Table.Cell>
            )
          : <Table.Cell textAlign="center" className={classes.contentCell}>{bye}</Table.Cell>
        }
      </Table.Row>
    );
  }

  renderTier = (tier, players) => {
    const playersByTier = players.filter(player => player.tier === tier);

    return (
      <fØ>
        { /* {(this.props.title.indexOf('top-200') === -1) && (
            <Table.Row>
            <Table.Cell textAlign="center" colSpan="5" className={classes.tierCell}>TIER {this.numeralNames[tier]}</Table.Cell>
            </Table.Row>
        )} */ }

        {playersByTier.map(player => this.renderPlayerRow(player))}
        </fØ>
    );
  }

  renderPositionTable = players => {
    const maxTier = players[players.length - 1].tier;
    const tiers = [];
    for (let i = 0; i < maxTier; i++) tiers.push(i + 1);
    let title = this.props.title;
    // const playerPosition = players[0].position;
    const combinedWRTE = this.props.profiles
      .find(profile => profile.id === this.props.selectedProfile).combine || undefined;
    const playerPosition = players[0].position === 'WR' && combinedWRTE ? 'wr,te' : players[0].position;

    return (
      <div className={classes.positionTable} key={playerPosition}>
        <Table unstackable celled>
          <Table.Header>
            {(title.indexOf('top-200') === -1) && (
              <Table.Row>
                <Table.HeaderCell  className={classes.tableTitle} colSpan="5" textAlign="center">
                  {positionToTitle(playerPosition, { plural: true, uppercase: true })}
                </Table.HeaderCell>
              </Table.Row>
            )}

            <Table.Row>
              <Table.HeaderCell textAlign="center" className={`${classes.rankHeader} ${classes.headercell}`}>
                { (title.indexOf('auction-') === -1) ? 'Rk' : 'Pcnt' }
              </Table.HeaderCell>
              {title === 'cheatsheets' && <Table.HeaderCell textAlign="center" className={`${classes.headercell} ${classes.ffptsHeader}`}>FF Pts</Table.HeaderCell>}
              {(title.indexOf('top-200') > -1) && <Table.HeaderCell textAlign="center" className={classes.headercell}>Pos</Table.HeaderCell>}
              <Table.HeaderCell textAlign="center" className={`${classes.headercell} ${classes.playerHeader}`}><span>Player</span></Table.HeaderCell>
              <Table.HeaderCell textAlign="center" className={classes.headercell}>Team</Table.HeaderCell>
              {
                title === 'cheatsheets'
                ? (this.props.selectedWeek < 1
                  ? <Table.HeaderCell textAlign="center" className={`${classes.headercell} ${classes.byeHeader}`}>Bye</Table.HeaderCell>
                  : <Table.HeaderCell textAlign="center" className={`${classes.headercell}`}>Opp</Table.HeaderCell>)
                : <Table.HeaderCell textAlign="center" className={`${classes.headercell} ${classes.byeHeader}`}>Bye</Table.HeaderCell>
              }
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {tiers.map(tier => this.renderTier(tier, players))}
          </Table.Body>
        </Table>
      </div>
    );
  }

  render = () => {
    const {
        selectedYear,
        selectedWeek,
        selectedProfile,
        weeks,
        hasLoaded,
        title,
        rookiesOnly,
        profiles,
      } = this.props;

    var { print } = this.props;
    var profileName = profiles && profiles.find(temp => (temp.id === selectedProfile)).name;

    const hasData = !!(print && typeof window !== 'undefined' && _.find(Object.values(print), position => position.length));

    let backLink = '';

    if (hasData) {
        backLink = location.href.split('/');
        backLink.length = 3;
        switch(title) {
            case 'cheatsheets': backLink = backLink.join('/') + '/cheatsheets?' + 'year=' + selectedYear + '&formulaId=' + selectedProfile + '&week=' + selectedWeek + '&rookiesOnly=' + rookiesOnly; break;
            case 'dynasty': backLink = backLink.join('/') + '/fantasy-football-rankings-cheat-sheets/' + selectedYear + '/dynasty'; break;
            case 'auction-10-team': backLink = backLink.join('/') + '/fantasy-football-rankings-cheat-sheets/' + selectedYear + '/auction-10-team'; break;
            case 'auction-12-team': backLink = backLink.join('/') + '/fantasy-football-rankings-cheat-sheets/' + selectedYear + '/auction-12-team'; break;
            case 'top-200-standard': backLink = backLink.join('/') + '/fantasy-football-rankings-cheat-sheets/' + selectedYear + '/top-200-standard'; break;
            case 'top-200-ppr': backLink = backLink.join('/') + '/fantasy-football-rankings-cheat-sheets/' + selectedYear + '/top-200-ppr'; break;
            case 'top-200-qb-heavy': backLink = backLink.join('/') + '/fantasy-football-rankings-cheat-sheets/' + selectedYear + '/top-200-qb-heavy'; break;
        }
    }

    return (
        <div className={classes.wrapper} >
          <div className={classes.firstContainer}>
            <div className={classes.topLeftContainer}>
                <div className={classes.title}>
                    {title === 'cheatsheets' && 'Fantasy Football Cheat Sheets'}
                    {title === 'dynasty' && 'Fantasy Football Cheat Sheets: Huddle Dynasty'}
                    {title === 'auction-10-team' && 'Fantasy Football Cheat Sheets: Huddle 10-Team Auction'}
                    {title === 'auction-12-team' && 'Fantasy Football Cheat Sheets: Huddle 12-Team Auction'}
                    {title === 'top-200-standard' && 'Fantasy Football Cheat Sheets: Top 200'}
                    {title === 'top-200-ppr' && 'Fantasy Football Cheat Sheets: Top 200 Point Per Reception (PPR) Scoring'}
                    {title === 'top-200-qb-heavy' && 'Fantasy Football Cheat Sheets: Top 200 Quarterback Heavy Scoring'}
                </div>
                <div className={classes.subtitle}>
                    <span>{`${selectedYear}, `}{title !== 'cheatsheets' ? null : selectedWeek === 0 ? 'Preseason,' : 'Week ' + `${selectedWeek}` + ','} {(selectedWeek === 0 && rookiesOnly === 'true') ? 'Rookies Only, ' : null} {title !== 'cheatsheets' ? null : `${profileName}` + ': '} </span>
                </div>
            </div>
            <div className={classes.topRightContainer}>
                <Image src={logo} className={classes.logo} />
                <a href={backLink}>Back to Cheat Sheets</a>
            </div>
          </div>

          <div className={classes.tableControls}>
                <TableControls injury playerStatus={title === 'cheatsheets' ? true : false} density={false} printable={true} />
          </div>

          {hasLoaded && hasData && (<div className={classes.tablesWrapper}>

            <table>
                <tbody>
                    <tr>
                        <td>
                            {this.props.print['QB'] && this.props.print['QB'].length && this.renderPositionTable(this.props.print['QB'])}
                            {this.props.print['TE'] && this.props.print['TE'].length && this.renderPositionTable(this.props.print['TE'])}
                            {this.props.print['PK'] && this.props.print['PK'].length && this.renderPositionTable(this.props.print['PK'])}
                            {this.props.print[1] && this.props.print[1].length && this.renderPositionTable(this.props.print[1])}
                        </td>
                        <td>
                            {this.props.print['RB'] && this.props.print['RB'].length && this.renderPositionTable(this.props.print['RB'])}
                            {this.props.print['DF'] && this.props.print['DF'].length && this.renderPositionTable(this.props.print['DF'])}
                            {this.props.print[2] && this.props.print[2].length && this.renderPositionTable(this.props.print[2])}
                        </td>
                        <td>
                            {this.props.print['WR'] && this.props.print['WR'].length && this.renderPositionTable(this.props.print['WR'])}
                            {this.props.print['WR/TE'] && this.props.print['WR/TE'].length && this.renderPositionTable(this.props.print['WR/TE'])}
                            {this.props.print[3] && this.props.print[3].length && this.renderPositionTable(this.props.print[3])}
                        </td>
                    </tr>
                </tbody>
            </table>
          </div>)}

        </div>
      );
  }
}
export default connect(mapStateToProps)(Print);



// WEBPACK FOOTER //
// ./src/app/views/Print/Print.js